import { Ref, Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { debounce } from 'lodash';

@Component
export class ListingFilter extends ThemeComponent {

    @Ref() filterInput!: HTMLInputElement;
    @Ref() listings!: HTMLDivElement[];
    @Ref() listingSections!: HTMLDivElement[];
    @Ref() listingMessage!: HTMLDivElement;
    @Ref({required: false}) listingMenu!: HTMLDivElement;

    private resultCount: boolean = false;

    init() {
        this.$listen(this.filterInput, 'keyup', debounce(() =>{
            this.filterListings(this.filterInput.value.toLowerCase());
        }, 300));
    }

    filterListings(value: string) {

        this.resultCount = false;
        this.listingMessage.classList.add('visually-hidden');

        if (value == '') {
            this.resetAll();
            return;
        }

        this.listingMenu.classList.add('visually-hidden');

        for (const section of this.listingSections) {
            section.classList.add('visually-hidden');
        }

        for (const listing of this.listings) {
            listing.classList.add('visually-hidden');
            const listingValue = listing.innerText.toLowerCase();
            if (listingValue.includes(value)) {
                this.resultCount = true;
                listing.classList.remove('visually-hidden');
                listing.closest('.listing-filter__section')?.classList.remove('visually-hidden');
            }
        }

        if (!this.resultCount) {
            this.listingMessage.innerText = 'No brands found, sorry.';
            this.listingMessage.classList.remove('visually-hidden');
        }
    }

    resetAll() {

        this.listingMenu.classList.remove('visually-hidden');

        for (const section of this.listingSections) {
            section.classList.remove('visually-hidden');
        }

        for (const listing of this.listings) {
            listing.classList.remove('visually-hidden');
        }
    }

}
